<script lang="ts">
  import Steps from "./Steps.svelte";
  import { email, lang, kiwiServerEndpoint } from "./stores";
  import { _ } from "svelte-i18n";
  import { Analytics, logEvent } from "firebase/analytics";

  export let analytics: Analytics;

  logEvent(analytics, 'registration_finished', { name: 'registration_finished'});

  function navigateToLogin(kiwiServerEndpoint: string, lang: string, email: string): void {
    logEvent(analytics, 'kiwi_server_login', { name: 'kiwi_server_login'});
    window.location.href = new URL(`/kiwi-server/app/login?lang=${lang}#username=${email}`, kiwiServerEndpoint).href;
  }
</script>

<div class="wrapper thanks">
  <div class="thanks-header">
    <h1>{$_("login.header")}</h1>
  </div>

  <div class="button-wrapper">
    <button
      on:click={() => {
        navigateToLogin($kiwiServerEndpoint, $lang, $email);
      }}>{$_("login.button")}</button
    >
  </div>

  <Steps>
    <img
      class="step-check-img"
      slot="email-check"
      src="./assets/check-6aa942.png"
      alt="check-6aa942"
    />
    <img
      class="step-img"
      slot="email"
      src="./assets/email-6bab43.png"
      alt="email-6bab43"
    />

    <img
      class="step-check-img"
      slot="password-check"
      src="./assets/check-6aa942.png"
      alt="check-6aa942"
    />
    <img
      class="step-img"
      slot="password"
      src="./assets/password-6bab43.png"
      alt="password-6bab43"
    />

    <img
      class="step-check-img"
      slot="login-check"
      src="./assets/check-d7d7d7.png"
      alt="check-d7d7d7"
    />
    <img
      class="step-img"
      slot="login"
      src="./assets/login-c9c9c9.png"
      alt="login-c9c9c9"
    />
  </Steps>
</div>

<style lang="less" scoped>
  .wrapper {
    padding-top: 6rem;
  }

  .button-wrapper {
    margin-bottom: 5rem;
  }

  button {
    font-size: 1.3rem;
    background-color: #6baa42;
    border: none;
    color: white;
    padding: 1.2rem 2.2rem;
    text-decoration: none;
    margin: 4px 2px;
    cursor: pointer;
    width: 22rem;
    text-transform: uppercase;
  }

  .thanks {
    display: flex;
    flex-flow: column;
    align-items: center;
  }

  .thanks-header {
    white-space: pre-line;
    text-align: center;
    margin-bottom: 2rem;
    h1 {
      margin-bottom: 2rem;
    }
  }

  @media only screen and (max-width: 600px) {
    .step-check-img {
      width: 2.3rem;
    }

    .step-img {
      width: 4rem;
    }

    .wrapper {
      padding-top: 3rem;
    }

    .button-wrapper {
      margin-bottom: 2.5rem;
    }

    button {
      font-size: 0.8rem;
      padding: 1rem 2rem;
      margin: 4px 2px;
      width: 18rem;
    }

    .thanks-header {
      margin-bottom: 1rem;
      h1 {
        font-size: 1.4rem;
        margin-bottom: 1rem;
      }
    }
  }
</style>
